import styled from 'styled-components';
import { breakpoints, css } from 'src/styles/theme';
import { SummaryPriceDetailsStyled } from '../SummaryPriceDetailsStyled';
import { rem } from 'polished';

export const SummaryPriceDetailsDS = styled(SummaryPriceDetailsStyled)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.secondary};

    ${({ isBasket }) =>
        !isBasket &&
        css`
            border-top: ${rem(1)} solid ${({ theme }) => theme.colors.secondary};
            border-bottom: ${rem(1)} solid ${({ theme }) => theme.colors.secondary};
        `}

    ${({ isBasket, isDealer }) =>
        !isBasket &&
        !isDealer &&
        css`
            border-top: unset;
            border-bottom: unset;
            @media (min-width: ${breakpoints.sm}px) {
                border-top: ${rem(1)} solid ${({ theme }) => theme.colors.secondary};
                border-bottom: ${rem(1)} solid ${({ theme }) => theme.colors.secondary};
            }
        `}
    .totalPriceWrapper {
        @media (max-width: ${breakpoints.md}px) {
            display: flex;

            .totalPrice {
                padding-top: unset !important;
                display: flex;
                flex-direction: column;
                align-items: flex-end;
            }
        }
    }

    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h4};
            text-transform: uppercase;
        }
    }
    .descriptionTitle {
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
    }
    .descriptionWrapper {
        border-color: ${({ theme }) => theme.colors.grey16};
        .info {
            .key {
                color: ${({ theme }) => theme.colors.grey29};
            }
        }
    }
    .totalPriceWrapper {
        .totalPriceTitle {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
        }
        .totalPrice {
            .cashPrice {
                font-size: ${({ theme }) => theme.fontSizes.h4};
            }
        }

        .monthlyPrice {
            .formatMoney {
                font-size: ${({ theme }) => theme.fontSizes.h4};
            }
        }

        .priceInfo {
            .amount,
            .promotionalText {
                font-size: ${({ theme }) => theme.fontSizes.h6};
            }
        }
    }
    .colorWrapper,
    .interiorWrapper,
    .optionWrapper,
    .priceWrapper {
        border-color: ${({ theme }) => theme.colors.grey16};
    }
    .configuration {
        button {
            color: ${({ theme }) => theme.colors.black1};

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.primary} !important;
                    }
                }
            }
        }
    }
    .infoIcon {
        svg {
            g {
                circle,
                line {
                    stroke: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }
`;
